import { Bars3Icon } from "@heroicons/react/24/outline";

interface MobileMenuButtonProps {
  onClick: () => void;
}

export function MobileMenuButton({ onClick }: MobileMenuButtonProps) {
  return (
    <div className="flex lg:hidden">
      <button
        type="button"
        className="inline-flex cursor-pointer items-center justify-center"
        onClick={onClick}
      >
        <span className="sr-only">Open main menu</span>
        <Bars3Icon
          className="h-8 w-8 rounded-md border border-white text-white"
          aria-hidden="true"
        />
      </button>
    </div>
  );
}